<template>
    <div class="row form-builder-template">
        <div class="col-md-8">
            <section-component :form="form" ref="SectionComponent" :gridId="gridId" :rowData="rowData"/>
        </div>
        <div class="col-md-4">
            <sidebar-component />
        </div>
        <preview-component
            v-if="!autonomous"
            ref="PreviewComponent"
            :form="form"
            :gridId="gridId"
            :rowData="rowData"
        />
    </div>
</template>

<script>
    import SectionComponent from "./ui/SectionComponent";
    import { dom } from '@fortawesome/fontawesome-svg-core'
    import SidebarComponent from "./ui/SidebarComponent";
    import PreviewComponent from "./ui/PreviewComponent";
    dom.watch();

    var default_form_value = () => ({
        sections: [],
        layout: "",
        _uniqueId: Math.random()
    });

    export default {
        name: "form-builder-template",
        components: {
            PreviewComponent,
            SidebarComponent,
            SectionComponent
        },
        props: {
            form: {
                type: Object
            },
            gridId: {
                type: String
            },
            rowData:{
                type: Object
            }
        },
        data () {
            return {
                autonomous: false
            }
        },
        methods: {
            getValue() {
                return this.form;
            },
            setValue(val) {
                this.form = val;
            },
            preview() {
                this.$refs.PreviewComponent.openModal(this.form);
            }
        },
        created () {
            this.autonomous = this.$parent.autonomous
        }
    }
</script>

<style scoped>

</style>
